import { observable, makeObservable, action } from 'mobx';
import { cancelOrder, deleteOrder, getOrderDetail } from '@/api/Payment/order';
import Toast from '@/components/Toast';
// import _ from 'lodash';
class Order {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        orderDetail: {},
        good: {}
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };
    //取消订单
    handleCancelOrder = async (id, data) => {
        let res = await cancelOrder(id, data);
        if (res && res.success) {
            return true;
        }
        Toast.error(res.msg || '取消订单失败');
        return false;
    };
    //删除订单
    handleDeleteOrder = async (id) => {
        let res = await deleteOrder(id);
        if (res && res.success) {
            Toast.success('删除成功');
            return true;
        }
        Toast.error(res.msg || '删除失败');
    };
    handleOrderDetail = async (id) => {
        let data = null,
         good = {},
         res = await getOrderDetail(id);
        if (res && res.success) {
            data = res.data;
            good = res.data.cart_info[0];
        } else {
            data = null;
            good = {};
        }
        this.setState({
            orderDetail: data,
            good
        });
    };
}
export default new Order();
